/**
 * Sales reports — `Report/TicketJson` (Bilet Satış Raporu) + `Report/PersonelTicketSalesReport`
 * (Personel Satış Raporu), ported into the API in backend Faz D. CONFIRMED live against
 * swagger 2026-08-27. Both routes take the same `SalesReportRequest`; `isPersonel`
 * toggles the personnel breakdown. The table is plain MUI; Excel export is client-side
 * (SheetJS) from the JSON rows.
 *
 * The response envelope is `SalesSummaryResponse`. CONFIRMED live 2026-08-27: the row
 * set comes back as `Rows` (→ `rows`), and the three `sum*` totals are **pre-formatted
 * currency strings** ("₺33.069,80"), not numbers — render them verbatim.
 */
import type { ResponseBase } from './common';

export interface SalesReportFilters {
  startDate: string;
  endDate: string;
  /** e.g. 'Booked' — legacy default. */
  status?: string;
  /** e.g. 'Air' — legacy default. */
  providerType?: string;
  provider?: string;
  username?: string;
  /** true → per-personnel breakdown (Personel Satış Raporu). */
  isPersonel?: boolean;
}

export interface SalesReportRow {
  [column: string]: unknown;
}

export interface SalesReportResponse extends ResponseBase {
  rows?: SalesReportRow[] | null;
  salesRows?: SalesReportRow[] | null;
  ticketSalesReports?: SalesReportRow[] | null;
  /** Count of tickets in the report. */
  sumTicket?: number;
  /** Pre-formatted currency strings from the backend, e.g. "₺33.069,80". */
  sumSalesAmount?: string;
  sumProfitAmount?: string;
}

/** Pull the row set out of whatever field the backend used. */
export function salesReportRows(res: SalesReportResponse | undefined): SalesReportRow[] {
  return res?.rows ?? res?.salesRows ?? res?.ticketSalesReports ?? [];
}
